import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RolloutProgressReportEntities } from '../../entities';
import { InspectionReportInitService } from '../../initial-values/inspection-report-init.service';

@Injectable({
  providedIn: 'root',
})
export class RolloutProgressReportAnswersApiService {
  url: string;

  constructor(
    private readonly http: HttpClient,
    private readonly initService: InspectionReportInitService,
  ) {
    this.url = this.initService.getInitValueProperty('urls').answers;
  }

  getAnswer(reportId: string, definitionId: string) {
    return this.http.get<RolloutProgressReportEntities.v3.AnswerResponse>(
      `${this.url}/${reportId}/self-inspection-definitions/${definitionId}/self-inspection-answer`,
    );
  }

  createAnswer = (
    reportId: string,
    definitionId: string,
    request: RolloutProgressReportEntities.v3.AnswerRequestType,
  ) =>
    this.http.post<RolloutProgressReportEntities.v3.AnswerWithGroupStatus>(
      `${this.url}/${reportId}/self-inspection-definitions/${definitionId}/self-inspection-answer`,
      request,
    );

  deleteAnswer = (reportId: string, definitionId: string) =>
    this.http.delete<void>(
      `${this.url}/${reportId}/self-inspection-definitions/${definitionId}/self-inspection-answer`,
    );

  createFile = (
    reportId: string,
    definitionId: string,
    fileFormData: FormData,
  ) => {
    return this.http.post<RolloutProgressReportEntities.v3.AnswerWithGroupStatus>(
      `${this.url}/${reportId}/self-inspection-definitions/${definitionId}/self-inspection-answer/files`,
      fileFormData,
    );
  };

  deleteFile = (reportId: string, definitionId: string, fileId: string) =>
    this.http.delete<void>(
      `${this.url}/${reportId}/self-inspection-definitions/${definitionId}/self-inspection-answer/files/${fileId}`,
    );
}
